import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { Link } from '@material-ui/core';
import DataTable, { DataTableColumn, Order, useDataTableStyles } from '../Components/DataTable';
import { AgentOverviewItem, SyndicateOverviewItem, SyndicateShareItem } from './AgentModels';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import { friendlyName } from '../common/helpers/RoundHelper';
import { formatNumber, formatToCurrency } from '../common/helpers/CurrencyHelpers';
import { numberToString } from '../common/helpers/StringUtils';
import { dateStringTicker } from '../common/helpers/DateHelpers';

interface SyndicateShareTableProps {
    syndicate?: SyndicateOverviewItem;
    items: SyndicateShareItem[];
    onSelect? : (item : SyndicateShareItem) => void;
}

const SyndicateShareTable: React.FC<SyndicateShareTableProps> = (props) => {
    const classes = useDataTableStyles();
    const [selectedId, setSelectedId] = useState<number>(0);
    const [columns, setColumns] = useState<DataTableColumn<SyndicateShareItem>[]>([]);

    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<SyndicateShareItem>[] = [
        { id: 'id', numeric: false, disablePadding: true, label: "Id", filterEnabled: true },
        { id: 'status', numeric: false, disablePadding: false, label: 'Status', filterEnabled: true },
        { id: 'couponShareId', numeric: false, disablePadding: true, label: "Coupon share", filterEnabled: true, renderValue: row => { return (<Link component={RouterLink} to={`couponView/${row.roundId}/${row.couponId}/${row.couponShareId}`}>{row.couponShareId}</Link>); } },
        { id: 'placedAt', numeric: false, disablePadding: false, label: 'Placed', renderValue: item => { return CreateRoundUtil.toDateTimeString(item.placedAt, true); }},
        { id: 'playerId', numeric: false, disablePadding: false, label: 'Player', filterEnabled: true },
        { id: 'stake', numeric: true, disablePadding: false, label: 'Stake', renderValue: item => { return formatToCurrency(item.stake, item.currency); } },
        { id: 'result', numeric: true, disablePadding: false, label: 'Result', renderValue: item => { return formatToCurrency(item.result, item.currency); } },
        { id: 'fee', numeric: true, disablePadding: false, label: 'Fee', renderValue: item => { return formatToCurrency(item.fee, item.currency); } },
        { id: 'agentFee', numeric: true, disablePadding: false, label: 'Agent Fee', renderValue: item => { return formatToCurrency(item.agentFee, item.currency); } },
        { id: 'currency', numeric: false, disablePadding: false, label: 'Currency', filterEnabled: true, visible: false },
      ];
      setColumns(cols);
    }
    const onSelect = (item : SyndicateShareItem) => {
        setSelectedId(item.id);
        if (props.onSelect){
          props.onSelect(item);
          return;
      }
    };
  
  return (
    <DataTable columns={columns} items={props.items} getId={it => it.id} orderBy='id' order='desc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect} rowsPerPage={25}  />
    );
};
  
export default SyndicateShareTable;
